import { render } from "./SnapshotZones.vue?vue&type=template&id=33c89b95&scoped=true"
import script from "./SnapshotZones.vue?vue&type=script&lang=js"
export * from "./SnapshotZones.vue?vue&type=script&lang=js"

import "./SnapshotZones.vue?vue&type=style&index=0&id=33c89b95&lang=less&scoped=true"

import exportComponent from "/home/baltazor/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c89b95"]])

export default __exports__